import { get } from 'lodash';

import userService from '../services/user-service';

export function isLoggedIn(store) {
  return (nextState, replace, callback) => {
    let { getState, dispatch } = store;
    if (!get(getState(), "loginState.isLoggedIn")) {
      return userService
        .getCurrentUser()
        .then((user) => {
          dispatch({
            type: "LOG_IN_COMPLETE",
            data: {
              user: user,
            },
          });
          callback();
        })
        .catch(() => {
          console.log("catchhhhhh ---- login");
          replace("/login");
          callback();
        });
    } else {
      callback();
    }
  };
}

export function isNotLoggedIn(store) {
  return (nextState, replace, callback) => {
    let { dispatch } = store;
    return userService
      .getCurrentUser()
      .then((user) => {
        dispatch({
          type: "LOG_IN_COMPLETE",
          data: {
            user: user,
          },
        });
        // replace('/login')
        callback();
      })
      .catch(() => {
        callback();
      });
  };
}



// WEBPACK FOOTER //
// ./src/utils/auth.js